// extracted by mini-css-extract-plugin
export default {"label":"LocationMapMarkerInfoWindow_label__BG-bv","address":"LocationMapMarkerInfoWindow_address__H7GXJ","typeIcon":"LocationMapMarkerInfoWindow_typeIcon__7HRe8"};